import React from 'react';
import cn from 'classnames';
// Styles
import styles from './ChipSelect.module.scss';

export type ChipSelectOption = {
  value: number;
  label: string;
};

type Props = {
  options: ChipSelectOption[];
  disabled?: boolean;
  className?: string;
  // Supplied by antd Form.Item, not by callers.
  value?: number | null;
  onChange?: (value: number) => void;
};

const ChipSelect: React.FC<Props> = ({
  options,
  disabled = false,
  className,
  value,
  onChange,
}) => {
  return (
    <div className={cn(styles.list, className)}>
      {options.map((option) => {
        const isSelected = value != null && Number(value) === option.value;

        return (
          <button
            type="button"
            key={option.value}
            aria-pressed={isSelected}
            disabled={disabled}
            className={cn(styles.chip, {
              [styles.selected]: isSelected,
              [styles.disabled]: disabled,
            })}
            onClick={() => {
              if (!disabled) {
                onChange?.(option.value);
              }
            }}
          >
            {option.label}
          </button>
        );
      })}
    </div>
  );
};

export default ChipSelect;
